/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Unit_PriceInputs */

const en_orders_unit_price = /** @type {(inputs: Orders_Unit_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unit Price`)
};

const es_orders_unit_price = /** @type {(inputs: Orders_Unit_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio unitario`)
};

/**
* | output |
* | --- |
* | "Unit Price" |
*
* @param {Orders_Unit_PriceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_unit_price = /** @type {((inputs?: Orders_Unit_PriceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Unit_PriceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_unit_price(inputs)
	return es_orders_unit_price(inputs)
});